"use client";

import React, { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { apiClient, profileApiClient } from "@/lib/axios";
import { queryClient } from "@/lib/queryClient";

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, token } = useAuth();

  useEffect(() => {
    const syncAuthHeaders = async () => {
      if (isAuthenticated && token) {
        apiClient.defaults.headers["Authorization"] = `Bearer ${token}`;
        apiClient.defaults.headers["x-privy-access-token"] = token;
        profileApiClient.defaults.headers["x-privy-access-token"] = token;
      } else {
        delete apiClient.defaults.headers["Authorization"];
        delete apiClient.defaults.headers["x-privy-access-token"];
        delete profileApiClient.defaults.headers["x-privy-access-token"];
      }

      await new Promise((resolve) => setTimeout(resolve, 150));

      queryClient.invalidateQueries({
        queryKey: [],
      });
    };

    syncAuthHeaders();
  }, [isAuthenticated, token]);

  return <>{children}</>;
};
